import { defineStore } from 'pinia';
import type { UserProfile } from '../types/api';
import { storage } from '../utils/storage';
import { api } from '../services/http';

export const useAuthStore = defineStore('auth', {
  state: () => ({ token: storage.get('token') || '', user: null as UserProfile | null, initialized: false, authorizationStartedAt: 0 }),
  actions: {
    apply(token: string, user: UserProfile) { this.token = token; this.user = user; storage.set('token', token); },
    clear() { this.token = ''; this.user = null; storage.remove('token'); },
    async initialize() {
      if (this.initialized) return;
      if (this.token) { try { this.user = await api.get<UserProfile>('/wechat/profile', undefined, { globalLoading: false }); } catch { this.clear(); } }
      this.initialized = true;
    },
    begin(returnPath: string) {
      const now = Date.now();
      if (now - this.authorizationStartedAt < 3_000) return;
      this.authorizationStartedAt = now;
      const query = new URLSearchParams({ returnPath });
      window.location.replace(`${import.meta.env.VITE_API_BASE_URL}/h5-auth/wechat/start?${query}`);
    },
    async claim() {
      const result = await api.post<{ token: string; user: UserProfile; returnPath: string }>('/h5-auth/session/claim', undefined, { globalLoading: false });
      this.apply(result.token, result.user); this.initialized = true; return result.returnPath;
    },
    async logout() { try { await api.post('/h5-auth/logout'); } finally { this.clear(); } },
  },
});
